export default "__VITE_ASSET__BsikdiIB__"